
import { computed, defineComponent, inject } from "vue";
import LoadingLayout from "@/common/layouts/Loading.vue";
import BaseLayout from "@/common/layouts/Base.vue";
import LoadingSpinner from "@/common/components/LoadingSpinner.vue";
import { loadingSpinner } from "@/common/services/loadingSpinner";
import DialogServiceComponent from "@/common/components/DialogServiceComponent.vue";
import router from "../router";

export default defineComponent({
  name: "App",

  components: {
    LoadingSpinner,
    LoadingLayout,
    BaseLayout,
    DialogServiceComponent,
  },

  setup() {
    const isErrorRoute = computed(() => {
      return (
        router.currentRoute.value.name === "Forbidden" ||
        router.currentRoute.value.name === "Not Found"
      );
    });

    return {
      profile: inject("profile"),
      loadingSpinner,
      isErrorRoute,
    };
  },

  computed: {
    loading(): boolean {
      return this.profile === undefined;
    },
  },
});
